var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLocationService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50275 5.12087L15.2252 2.49746C15.6281 2.34023 15.8296 2.26162 15.9583 2.30462C16.0701 2.34197 16.1578 2.42969 16.1951 2.54148C16.2381 2.6702 16.1595 2.87164 16.0023 3.27453L13.3705 10.0185M12.2892 12.7893L11.0596 15.9403C10.8854 16.3866 10.7983 16.6098 10.6731 16.6748C10.5646 16.7312 10.4354 16.7311 10.327 16.6746C10.2019 16.6094 10.1151 16.3862 9.94141 15.9397L7.97033 10.8712C7.93508 10.7805 7.91746 10.7352 7.89024 10.6971C7.86611 10.6632 7.83653 10.6337 7.80271 10.6095C7.76455 10.5823 7.71923 10.5647 7.62859 10.5294L2.56009 8.55836C2.11358 8.38472 1.89033 8.2979 1.82515 8.17279C1.76864 8.06434 1.76857 7.93516 1.82494 7.82664C1.88997 7.70146 2.11313 7.61438 2.55943 7.44021L5.71311 6.20951M15.7496 16.2501L2.24964 2.75013",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationService);
export default __webpack_public_path__ + "static/media/noLocationService.2813e763132900c6cf558136bd7739dc.svg";
export { ForwardRef as ReactComponent };